import z from "zod";
import { BillingFrequency, CurrencyType, OfferingType, ServiceType } from "./offering";
import { addDays, startOfDay } from "date-fns";

export const addOfferingPriceSchema = () => {
  return z.object({
    price: z.number().positive('El precio debe ser positivo'),
    currency: z.enum(Object.values(CurrencyType)),
    effectiveFrom: z.date().refine(date => startOfDay(date) >= addDays(startOfDay(new Date()), 1), {
      message: 'La fecha "desde" debe ser mayor o igual a la fecha actual',
    }),
    effectiveUntil: z.date().optional().refine(date => !date || (date && startOfDay(date) > startOfDay(new Date())), {
      message: 'La fecha "hasta" debe ser mayor o igual a la fecha actual',
    }),
  }).refine(
    (data) => {
      if (data.effectiveUntil) {
        return startOfDay(data.effectiveUntil) > startOfDay(data.effectiveFrom);
      }
      return true;
    },
    {
      message: 'La fecha "hasta" debe ser posterior a la fecha "desde"',
      path: ['effectiveUntil'],
    }
  );
}

export const addOfferingPriceWithAgesSchema = () => {
  return z.object({
    price: z.number().positive('El precio debe ser positivo'),
    currency: z.enum(Object.values(CurrencyType)),
    effectiveFrom: z.date().refine(date => startOfDay(date) >= addDays(startOfDay(new Date()), 1), {
      message: 'La fecha "desde" debe ser mayor o igual a la fecha actual',
    }),
    effectiveUntil: z.date().optional().refine(date => !date || (date && startOfDay(date) > startOfDay(new Date())), {
      message: 'La fecha "hasta" debe ser mayor o igual a la fecha actual',
    }),
    agePricingRanges: z.array(z.object({
      rangeStart: z.number(),
      rangeEnd: z.number(),
      price: z.number(),
    })).optional(),
  }).refine(
    (data) => {
      if (data.effectiveUntil) {
        return startOfDay(data.effectiveUntil) > startOfDay(data.effectiveFrom);
      }
      return true;
    },
    {
      message: 'La fecha "hasta" debe ser posterior a la fecha "desde"',
      path: ['effectiveUntil'],
    }
  );
}


export const enhancedCreateOfferingSchema = z.object({
  name: z.string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede tener más de 100 caracteres'),
  code: z.string()
    .min(1, 'El código debe tener al menos 1 caracter')
    .max(20, 'El código no puede tener más de 20 caracteres')
    .regex(/^[A-Za-z0-9-]+$/, 'El código solo puede contener letras mayúsculas, números o guiones'),
  serviceType: z.enum(Object.values(ServiceType)).nullable(),
  description: z.string()
    .max(500, 'La descripción no puede tener más de 500 caracteres')
    .optional(),
  offeringType: z.enum(Object.values(OfferingType)),
  basePrice: z.number()
    .min(1, 'El precio debe ser mayor a 0'),
  currency: z.enum(Object.values(CurrencyType)),
  billingFrequency: z.enum(Object.values(BillingFrequency)),
  taxRate: z.number()
    .min(0, 'La tasa de impuesto no puede ser negativa')
    .max(100, 'La tasa de impuesto no puede ser mayor a 100%'),
  isTaxable: z.boolean(),
  isInvoiceable: z.boolean(),
  hasMultipleOffered: z.boolean(),
  hasPaymentPlanAvailable: z.boolean(),
  hasAgePricing: z.boolean(),
  isAdditional: z.boolean().default(false),
})
  .refine(
    (data) => {
      if (data.offeringType === OfferingType.ONE_TIME) {
        return data.billingFrequency === BillingFrequency.ONE_TIME;
      }
      return true;
    },
    {
      message: 'Los servicios de única vez deben tener frecuencia "Única vez"',
      path: ['billingFrequency']
    }
  );

